import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import usePrams -> to get movieid from url in details page
import { fetchMovie } from "../../redux/actions/FetchActions"
import { fetchMovies } from "../../redux/reducers/FetchReducer";
import MovieCard from "./MovieCard";

function MovieList() {
    // const navigate = useNavigate();
    const dispatch = useDispatch();
    const movies = useSelector((state) => state.allData.movies); // state.allData.movies for all movies
    

    useEffect(() => {
        fetchMovie().then((res)=>{
            dispatch(fetchMovies(res.data.results));
        });        
    }, []);
    
    return (
        <div className="flex pb-5 px-5 overflow-x-auto">
            
            { movies?.map((movie, index) => {
                console.log("Tes ", movie.id);
                return <MovieCard key={index} movie={movie} />  
                // onClick={()=> navigate(`/movies/${movie.id}`)}
            })}
        </div>
        
    );
}

export default MovieList;
